import { create } from 'zustand';
import { ScreenType } from 'types';
import { SCREEN_TYPES } from 'utils/constants';

interface AppState {
  currentScreen: ScreenType;
  setCurrentScreen: (screen: ScreenType) => void;
  reset: () => void;
  barcodeDebugMessage: string;
  setBarcodeDebugMessage: (message: string) => void;
}

export const useAppStore = create<AppState>((set) => ({
  currentScreen: SCREEN_TYPES.LOGIN,
  setCurrentScreen: (screen: ScreenType) => set({ currentScreen: screen }),
  reset: () =>
    set({
      currentScreen: SCREEN_TYPES.LOGIN,
    }),
  barcodeDebugMessage: '',
  setBarcodeDebugMessage: (message: string) => set({ barcodeDebugMessage: message }),
}));
